import React from "react";
import { Package, LogOut, ShoppingBag } from "lucide-react";
import { Logo } from "@/components/Logo";
import NotificationBell from "@/components/NotificationBell";
import EcommerceResiPanel from "@/components/EcommerceResiPanel";
import { useAuth } from "@/context/AuthContext";

export default function EcommerceDashboard({ demo }) {
  const { user, logout } = useAuth();
  const displayName = user?.name || (demo ? "Admin E-commerce" : "Admin E-commerce");

  return (
    <div className="min-h-screen bg-showty-cream showty-grain flex" data-testid="ecommerce-dashboard">
      <aside className="hidden lg:flex flex-col w-64 shrink-0 bg-[#fdf6ec] border-r border-border sticky top-0 h-screen">
        <div className="px-6 py-6 flex items-center gap-2.5">
          <Logo className="w-9 h-9" />
          <div><p className="font-display text-2xl leading-none text-showty-navy">Showtynion</p><p className="text-[10px] tracking-[0.2em] uppercase text-showty-red mt-1">E-commerce Admin</p></div>
        </div>
        <nav className="flex-1 px-3 space-y-1">
          <div className="w-full flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-sm font-medium bg-showty-navy text-white shadow-sm" data-testid="section-resi">
            <Package className="w-4 h-4" /> Kelola Resi Shopee
          </div>
        </nav>
        <div className="px-6 py-5 flex items-center gap-2 text-[#ee4d2d]"><ShoppingBag className="w-4 h-4" /><span className="font-display text-sm">Shopee Resi Center</span></div>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="sticky top-0 z-30 bg-showty-cream/85 backdrop-blur-xl border-b border-border px-4 sm:px-8 py-3.5 flex items-center justify-between gap-3">
          <p className="font-display text-xl text-showty-navy flex items-center gap-2"><ShoppingBag className="w-5 h-5 text-[#ee4d2d]" /> Admin Resi Shopee</p>
          <div className="flex items-center gap-2.5">
            {!demo && <NotificationBell />}
            <div className="flex items-center gap-2.5 pl-1">
              <div className="w-10 h-10 rounded-full bg-showty-navy flex items-center justify-center text-white font-semibold">{displayName[0]}</div>
              <div className="hidden sm:block leading-tight"><p className="text-sm font-semibold text-showty-navy">{displayName}</p><p className="text-xs text-muted-foreground">E-commerce Admin</p></div>
              <button onClick={logout} className="text-muted-foreground hover:text-showty-red" data-testid="logout-btn"><LogOut className="w-4 h-4" /></button>
            </div>
          </div>
        </header>

        <main className="flex-1 px-4 sm:px-8 py-6 max-w-[1400px] w-full">
          <div className="mb-5">
            <h1 className="font-display text-3xl sm:text-4xl text-showty-navy">Kelola Resi Shopee</h1>
            <p className="text-sm text-muted-foreground mt-1">Upload resi (PDF/foto), kaitkan ke member, dan atur status pengiriman. Member akan melihatnya di menu Tracking Order.</p>
          </div>
          {demo ? (
            <div className="rounded-2xl border border-dashed border-border bg-white/50 py-16 text-center text-sm text-muted-foreground">Mode demo — login sebagai admin e-commerce untuk mengelola resi.</div>
          ) : <EcommerceResiPanel />}
        </main>
      </div>
    </div>
  );
}
